module.exports = __webpack_public_path__ + "img/poodle.c75c37b1.png";